'use client';

import React, { useState } from 'react';
import AppLayout from '@/components/AppLayout';
import TransfersHeader from './components/TransfersHeader';
import TransfersTableSection from './components/TransfersTableSection';
import InitiateTransferModal from './components/InitiateTransferModal';
import type { Transfer } from '@/lib/transfers/types';

export default function TransfersPage() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newTransfer, setNewTransfer] = useState<Transfer | null>(null);

  const handleCreateTransfer = (transfer: Transfer) => {
    setNewTransfer(transfer);
    setShowCreateModal(false);
  };

  return (
    <AppLayout data-component-id="src\app\transfers\page.tsx:20:4" data-component-path="src\app\transfers\page.tsx" data-component-line="20" data-component-end-line="31" data-component-file="page.tsx" data-component-name="AppLayout" data-component-content="%7B%22elementName%22%3A%22AppLayout%22%7D">
      <div data-component-id="src\app\transfers\page.tsx:21:6" data-component-path="src\app\transfers\page.tsx" data-component-line="21" data-component-end-line="24" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22px-6%20lg%3Apx-8%20xl%3Apx-10%20py-6%20max-w-screen-2xl%20mx-auto%20space-y-6%22%7D" className="px-6 lg:px-8 xl:px-10 py-6 max-w-screen-2xl mx-auto space-y-6">
        <TransfersHeader data-component-id="src\app\transfers\page.tsx:22:8" data-component-path="src\app\transfers\page.tsx" data-component-line="22" data-component-end-line="22" data-component-file="page.tsx" data-component-name="TransfersHeader" data-component-content="%7B%22elementName%22%3A%22TransfersHeader%22%7D" onInitiateTransfer={() => setShowCreateModal(true)} />
        <TransfersTableSection data-component-id="src\app\transfers\page.tsx:23:8" data-component-path="src\app\transfers\page.tsx" data-component-line="23" data-component-end-line="23" data-component-file="page.tsx" data-component-name="TransfersTableSection" data-component-content="%7B%22elementName%22%3A%22TransfersTableSection%22%7D" newTransfer={newTransfer} />
      </div>

      <InitiateTransferModal data-component-id="src\app\transfers\page.tsx:26:6" data-component-path="src\app\transfers\page.tsx" data-component-line="26" data-component-end-line="30" data-component-file="page.tsx" data-component-name="InitiateTransferModal" data-component-content="%7B%22elementName%22%3A%22InitiateTransferModal%22%7D"
        open={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onCreateTransfer={handleCreateTransfer}
      />
    </AppLayout>
  );
}
